<template>
    <vertical-form-table v-model="form" v-bind="{ items }" @input="emit">
        <template #학력>
            <form-qualification-education v-model="form.qualification" @input="emit" />
        </template>
        <template #경력>
            <form-qualification-experience v-model="form.qualification" @input="emit" />
        </template>
        <template #연령>
            <form-qualification-age v-model="form.qualification" @input="emit" />
        </template>
        <template #성별>
            <form-qualification-gender v-model="form.qualification" @input="emit" />
        </template>
    </vertical-form-table>
</template>

<script>
import { initRecruitment } from "@/assets/variables";

import VerticalFormTable from "@/components/dumb/vertical-form-table.vue";
import FormQualificationAge from "./form-qualification-age.vue";
import FormQualificationGender from "./form-qualification-gender.vue";
import FormQualificationEducation from "./form-qualification-education.vue";
import FormQualificationExperience from "./form-qualification-experience.vue";

export default {
    components: {
        VerticalFormTable,
        FormQualificationAge,
        FormQualificationGender,
        FormQualificationEducation,
        FormQualificationExperience,
    },
    props: {
        value: { type: Object, default: initRecruitment },
    },
    data: () => ({
        form: initRecruitment(),
    }),
    computed: {
        items() {
            return [
                // {
                //     term: "학력",
                // },
                {
                    term: "경력",
                    required: true,
                },
                // {
                //     term: "연령",
                // },
                // {
                //     term: "성별",
                // },
            ].map((item) => ({ ...item, outlined: true }));
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.form = initRecruitment(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
    },
};
</script>

<style>
</style>